import { createFileRoute } from "@tanstack/react-router";
import Navbar from "@/components/Navbar";
import CityHeroShared from "@/components/CityHeroShared";
import CityMap from "@/components/CityMap";
import CityUseCases from "@/components/CityUseCases";
import MobileBookNowFab from "@/components/MobileBookNowFab";
import VehicleTypeIcons from "@/components/VehicleTypeIcons";
import FleetMeatSection, { ReviewsSection } from "@/components/FleetMeatSection";
import SprinterSpecsSection from "@/components/SprinterSpecsSection";
import SeoLongform from "@/components/SeoLongform";
import GeoAnswerBlock from "@/components/GeoAnswerBlock";
import { MINNEAPOLIS_REVIEWS } from "@/data/reviews/minneapolis";
import { cityHeadMeta } from "@/data/citySeo";

export const Route = createFileRoute("/minneapolis")({
  component: MinneapolisLanding,
  head: () => ({
    meta: [
      ...cityHeadMeta("minneapolis"),
      { property: "og:image", content: "https://sprinter-van-rentals.com/__l5e/assets-v1/d9d070c6-6676-46c4-b0f4-9b0498e3c905/van-lot-og.jpg" },
      { property: "twitter:image", content: "https://sprinter-van-rentals.com/__l5e/assets-v1/d9d070c6-6676-46c4-b0f4-9b0498e3c905/van-lot-og.jpg" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://sprinter-van-rentals.com/minneapolis" }],
  }),
});

function MinneapolisLanding() {
  return (
    <main className="min-h-screen bg-white text-[#0F172A]">
      <Navbar />
      <MobileBookNowFab />
      <CityHeroShared
        citySlug="minneapolis"
        cityLabel="Minneapolis"
        headline={"Minneapolis\nSprinter Van Rentals"}
        intro="Minneapolis Sprinter van rentals seating 12 and 15 passengers with full luggage space — delivered curbside at MSP and across the Twin Cities."
      />
<section id="fleet" className="max-w-[1440px] mx-auto px-6 pt-12 md:pt-16 pb-24 scroll-mt-24">
        <div className="mb-10">
          <p className="font-display font-bold text-xs uppercase tracking-[0.4em] mb-3 text-[#F97316]">Minneapolis Sprinter Van Rentals</p>
          <h2 className="font-display font-black text-5xl md:text-6xl tracking-tight text-[#0F172A]">
            Choose a 12 or 15 seat Sprinter in Minneapolis.
          </h2>
        </div>
        <VehicleTypeIcons accent="#F97316" citySlug="minneapolis" />

      </section>

      <CityMap citySlug="minneapolis" accent="#F97316" />
      <ReviewsSection city="minneapolis" accent="#F97316" dark accentSecondary="#FFB347" reviewCity="Minneapolis" reviews={MINNEAPOLIS_REVIEWS} />
      <SprinterSpecsSection city="minneapolis" accent="#F97316" />
      <FleetMeatSection city="minneapolis" accent="#F97316" dark accentSecondary="#FFB347" reviewCity="Minneapolis" />
      <SeoLongform citySlug="minneapolis" />
      <GeoAnswerBlock citySlug="minneapolis" />
      <CityUseCases citySlug="minneapolis" accent="#F97316" />
      <footer className="py-8 text-center border-t border-[#0F172A]/8">
        <p className="text-[#0F172A]/50 text-xs tracking-widest uppercase">&copy; 2026 Sprinter Van Rentals · Minneapolis</p>
      </footer>
    </main>
  );
}
